import React from "react";
import BuyPermitsPage from "../../components/Pages/BuyPermitsPage";
import Layout from "./Layout";
import PageTitle from "../../components/PageTitle";

const ConnectedBuyPermitsPage = (props) => {
  return (
    <>
      <PageTitle label="Buy Permit" />
      <Layout isPrelogin={false} >
        <BuyPermitsPage />
      </Layout>
    </>
  );
};
export default ConnectedBuyPermitsPage;
